import React from 'react';

// Posing-guidance chip (icon + label) used on the Create surface — the desktop
// scan info card and the mobile photo-picker modal share it.
const TipChip = ({ icon, label }) => (
  <div className="flex-1 flex items-center gap-2.5 bg-[#161615] border border-[rgba(255,255,255,0.07)] rounded-field px-3 py-[11px] lg:px-4 lg:py-3.5">
    <span className="text-aurum flex shrink-0" aria-hidden="true">{icon}</span>
    <span className="font-display text-xs lg:text-sm text-[#B8B2A6]">{label}</span>
  </div>
);

export default TipChip;
